import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import config from '../../config';

export default class AuthenticatedRoute extends Component {
  static propTypes = {
    user: PropTypes.obj,
    authenticate: PropTypes.func,
    component: PropTypes.element,
    authenticateFail: PropTypes.bool,
    path: PropTypes.str,
    exact: PropTypes.bool,
    roles: PropTypes.arr
  }

  componentDidUpdate() {
    if (this.props.payload && !this.props.user) {
      this.props.authenticate();
    }
  }

  render() {
    const { component: RenderThis, user, roles, authenticate, authenticateFail, ...spread } = this.props;
    if (authenticateFail || !this.props.payload) return (<Route render={() => window.location = `${config.authUrl}?redirect=${window.location.pathname + window.location.search}`} exact={spread.exact} path={spread.path} />);
    return (<Route render={() => {
      if (user && (!roles || roles.filter(x => new Set(user.roles).has(x)).length)) {
        return <RenderThis />
      } else if (user) {
        return <div>You're unauthorized to see this page, Bugger off</div>
      }
      return <div className="loading-widget-dimmer">
            <div className="loading-widget loading-widget_main">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <g fill="none" fill-rule="evenodd">
                        <path className="loading-widget__draw-animation" stroke="#4061AD" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M19.783 5.792V.793c0-.581-.476-.82-1.057-.555L6.137 6.188c-.582.265-1.058.952-1.058 1.534v20.972c0 .582.476.82 1.058.556l13.62-6.427-4.655 2.222V13.488l-2.565 1.269v-5.58l7.246-3.385z"/>
                        <path className="loading-widget__draw-animation" stroke="#14AFE4" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M26.21 2.75L18.435 6.4l1.322-.635V22.77l-4.655 2.195V13.488l-2.538 1.269v16.45c0 .581.476.82 1.057.555l12.589-5.924c.582-.264 1.058-.952 1.058-1.534V3.332c0-.608-.476-.846-1.058-.582z"/>
                    </g>
                </svg>
            </div>
             </div>
    }} {...spread} />);
  }
}



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRouteComponent/AuthenticatedRoute.js